import { AxiosInstance } from 'axios';
import { Picklist } from '@trukt/types/Picklist';

export type PicklistGetResponse = Picklist;

export class PicklistService {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  get() {
    return this.instance.get<PicklistGetResponse>('/picklist/options');
  }
}
